import React from "react";
import Marquee from "react-fast-marquee";
import logo1 from "../../../assets/img/logo/Ideal.png";
import logo2 from "../../../assets/img/logo/Siamp.png";
import logo3 from "../../../assets/img/logo/Acova.png";
import logo4 from "../../../assets/img/logo/hansgrohe.png";
import logo5 from "../../../assets/img/logo/Ramon-Soler.png";
import logo6 from "../../../assets/img/logo/Delabie.png";
import logo7 from "../../../assets/img/logo/Grohe.png";
import logo8 from "../../../assets/img/logo/Atlantic.png";
import logo9 from "../../../assets/img/logo/Comap.png";
import logo10 from "../../../assets/img/logo/De-Dietrich.png";
import logo11 from "../../../assets/img/logo/Plombelec.png";

import illu1 from "../../../assets/img/illu/knowlege/knowlege1.webp";
import illu2 from "../../../assets/img/illu/knowlege/knowlege2.webp";
import illu3 from "../../../assets/img/illu/knowlege/knowlege3.webp";

import "./knowlege.css";

export default function Knowlege() {
  const logos = [
    { src: logo1, href: "https://www.ideal.com" },
    { src: logo2, href: "https://siamp.fr/" },
    { src: logo3, href: "https://www.acova.fr/" },
    { src: logo4, href: "https://www.hansgrohe.fr/" },
    { src: logo5, href: "https://rsramonsoler.com/fr/" },
    { src: logo6, href: "https://www.delabie.fr/" },
    { src: logo7, href: "https://www.grohe.fr/fr_fr/" },
    { src: logo8, href: "https://www.atlantic.fr/" },
    { src: logo9, href: "https://www.comapwt.com/fr/" },
    { src: logo10, href: "https://www.dedietrich-thermique.fr/" },
    { src: logo11, href: "https://www.plombelec.com" },
  ];

  return (
    <section className="Knowlege">
      <div className="banner">
        <Marquee gradient={false} speed={75} loop={0} pauseOnHover={true}>
          {logos.map(({ src, href }, idx) => (
            <a
              key={idx}
              href={href}
              className="banner-item"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={src}
                alt={`Logo partenaire ${idx + 1}`}
                className="logos__item"
              />
            </a>
          ))}
        </Marquee>
      </div>

      <div className="showcase">
        <div className="chronology">
          <div className="chronology__images">
            <div className="img-wrapper img-1949">
              <img src={illu1} alt="Nice Plomberie en 1949" />
            </div>
            <div className="img-wrapper img-2007">
              <img src={illu2} alt="Nice Plomberie en 2007" />
            </div>
            <div className="img-wrapper img-today">
              <img src={illu3} alt="Nice Plomberie aujourd'hui" />
            </div>
          </div>
          <div className="chronology__timeline">
            <div className="timeline-item">
              <span className="year">1949</span>
            </div>
            <div className="timeline-line"></div>
            <div className="timeline-item">
              <span className="year">2007</span>
            </div>
            <div className="timeline-line"></div>
            <div className="timeline-item">
              <span className="year">Aujourd'hui</span>
            </div>
          </div>
        </div>
        <div className="Knowlege__text">
          <div className="Knowlege__highlight">
            <p>Depuis 1949</p>
            <h3>75 ans de Savoir Faire</h3>
          </div>
        </div>
      </div>
    </section>
  );
}
